module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-3-94a7a8dab7bc3106fb235ac49fd6e3be.jpg";